import { SponsorsGrid } from "../components/Sponsors"

export default function Mitorganisatoren() {
    return (
        <section>
            <h1>Mitorganisatoren des DUOdays</h1>
           
                    <SponsorsGrid
                      headline="Schirmherrschaft und Mitorganisatoren"
                      mainSponsors={[
                        {
                          name: "Landeshauptstadt Hannover",
                          logoSrc: "../sponsors/LandeshauptstadtHannover.png",
                        },
                        {
                          name: "enercity",
                          logoSrc: "../sponsors/enercity.png",
                          href: "https://www.enercity.de",
                        },
                        {
                          name: "Region Hannover",
                          logoSrc: "../sponsors/region-hannover.png",
                        },
                      ]}
                      
                      sponsorsRow2={[
                        { name: "Sparkasse Hannover", logoSrc: "../sponsors/Sparkasse-Hannover.png" },
                        { name: "Stadt Barsinghausen", logoSrc: "../sponsors/Stadt-Barsinghausen.png" },
                        { name: "Conti", logoSrc: "../sponsors/Conti.png" },
                        { name: "BGPhoenics", logoSrc: "../sponsors/BGPhoenics.png" },
                      ]}
                      sponsorsRow3={[
                        { name: "BdC", logoSrc: "../sponsors/BdC_EH_Werkstaetten_Hannover.png" },
                        { name: "IFD", logoSrc: "../sponsors/IFD.png" },
                        { name: "Lebenshilfe Seelze", logoSrc: "../sponsors/lebenshilfeSeelze.svg" },
                        { name: "Hannoversche Werkstätten", logoSrc: "../sponsors/HannoverscheWerkstaetten.svg" },
                      ]}
                    />
                  </section>

    );
}